import { render, staticRenderFns } from "./productSameList.vue?vue&type=template&id=34b8c5b4&scoped=true"
import script from "./productSameList.vue?vue&type=script&lang=js"
export * from "./productSameList.vue?vue&type=script&lang=js"
import style0 from "./productSameList.vue?vue&type=style&index=0&id=34b8c5b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34b8c5b4",
  null
  
)

export default component.exports